import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
  return typeof error === 'object' && error != null && 'status' in error;
}

export function isErrorWithMessage(error: unknown): error is { message: string } {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return typeof error === 'object' && error != null && 'message' in error && typeof (error as any).message === 'string';
}

const handleError = (error: unknown): string | undefined => {
  if (!error) {
    return undefined;
  }
  if (isFetchBaseQueryError(error)) {
    if ('error' in error) {
      return error.error;
    }
    if (error.data != null && typeof error.data === 'object' && 'errorMessage' in error.data) {
      return (error.data as { errorMessage: string }).errorMessage;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return error.data?.error ? error.data.error : JSON.stringify(error.data);
  }
  if (isErrorWithMessage(error)) {
    return error.message;
  }

  return 'An unknown error occurred';
};

export default handleError;
